const isMarketingOnly = false;

export { isMarketingOnly };
